import { BRAND_MARQUEE } from "../data/brands";

function Item({ brand }) {
  return (
    <div className="mx-4 grid h-16 w-36 shrink-0 place-items-center rounded-xl border border-border bg-white px-4">
      {brand.logo ? (
        <img
          src={brand.logo}
          alt={`${brand.name} logo`}
          loading="eager"
          className="max-h-9 max-w-[80%] object-contain transition-transform duration-300 hover:scale-105"
        />
      ) : (
        <span className="whitespace-nowrap font-serif-display text-base text-neutral-500">{brand.name}</span>
      )}
    </div>
  );
}

export default function BrandMarquee() {
  const loop = [...BRAND_MARQUEE, ...BRAND_MARQUEE];
  return (
    <section className="py-14 overflow-hidden" data-testid="brand-marquee">
      <div className="max-w-7xl mx-auto px-6 mb-8 text-center">
        <p className="label-caps text-accent">Trusted Brand Partners</p>
      </div>
      <div className="relative">
        <div className="pointer-events-none absolute inset-y-0 left-0 z-10 w-24 bg-gradient-to-r from-background to-transparent" />
        <div className="pointer-events-none absolute inset-y-0 right-0 z-10 w-24 bg-gradient-to-l from-background to-transparent" />
        <div className="flex w-max animate-marquee hover:[animation-play-state:paused]">
          {loop.map((b, i) => (
            <Item key={`${b.name}-${i}`} brand={b} />
          ))}
        </div>
      </div>
    </section>
  );
}
